import { computed } from 'vue';
import { useFilters } from '@/Composables/Filters/useFilters.js';
import {
    buildDefaultPledgesAndOrdersFilterParams,
    buildPledgesAndOrdersFilterList,
    buildPledgesAndOrdersSortList,
    buildPledgesAndOrdersCurrentFilter,
    removeSearchSelectedFilter,
} from '@/Utils/Views/BackerCenterViewPledgesAndOrdersUtility';
import { apiClient } from '@/Clients/ApiClient';
import UsersService from '@/Services/UsersService';
import Resources from '@/Resources.js';
import { pledgeSortTypes } from '@/Models';
import { convertArrayParamsToCommaSeparatedList } from '@/Utils/FiltersUtility.js';

const usersService = new UsersService(apiClient);

export function useBackerCenterPledgesAndOrdersFilters() {

    const baseFilters = useFilters({
        buildDefaultFilterParams: buildDefaultPledgesAndOrdersFilterParams,
        buildCurrentFilter: buildPledgesAndOrdersCurrentFilter,
        buildFilterList: buildPledgesAndOrdersFilterList,
        buildSortList: buildPledgesAndOrdersSortList,
        removeSelectedFilter: removeSearchSelectedFilter,
        storageKey: 'pledgesAndOrdersSearchParams',
        apiLoadMethod: async (params, loadMore) => {
            const formattedParams = convertArrayParamsToCommaSeparatedList(params);
            const { data } = await usersService.getBackerCenterPledges(formattedParams);
            return {
                ...data.pagedPledges,
                searchResultQuery: data.searchResultQuery,
                params: data.params,
            };
        },
        resources: { ...Resources.BackerCenter, ...Resources.OrderStatus, ...Resources.Common },
        sortEnum: pledgeSortTypes,
    });

    const hasOrders = computed(() => baseFilters.hasItems.value);

    return {
        ...baseFilters,
        hasOrders,
    };
}